import { Color, Flex, ModalConfirmation, Spacing, Text, useModal } from '@billy/design-system'
import { ReactElement, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'

interface FecImportResumeDeleteModalProps {
  isDeleting: boolean
  onConfirm: () => Promise<void>
}

export const FecImportResumeDeleteModal = ({
  isDeleting,
  onConfirm,
}: FecImportResumeDeleteModalProps): ReactElement => {
  const [isError, setIsError] = useState(false)
  const { t } = useTranslation()
  const { close } = useModal(ModalId.FecImportResumeDeleteModal)

  const handleOk = useCallback(async () => {
    try {
      await onConfirm()
      setIsError(false)
      close()
    } catch {
      setIsError(true)
    }
  }, [close, onConfirm])

  return (
    <ModalConfirmation
      cancelLabel={t('settings.organization.accounting.fec_file_import.modal.resume_step.delete_modal.return_button')}
      danger
      id={ModalId.FecImportResumeDeleteModal}
      message={
        <Flex flexDirection="column" gap={Spacing.S8}>
          <Text colorVariant="secondary">
            {t('settings.organization.accounting.fec_file_import.modal.resume_step.delete_modal.message')}
          </Text>
          {isError && (
            <Text color={Color.Red700}>
              {t('settings.organization.accounting.fec_file_import.modal.resume_step.delete_modal.error')}
            </Text>
          )}
        </Flex>
      }
      okLabel={t('settings.organization.accounting.fec_file_import.modal.resume_step.delete_modal.confirm_button')}
      okLoading={isDeleting}
      onClose={() => setIsError(false)}
      onOk={handleOk}
      title={t('settings.organization.accounting.fec_file_import.modal.resume_step.delete_modal.title')}
    />
  )
}
